import { Suspense } from "react";
import { Link } from "react-router-dom";

import { Score } from "./score";
import { Button } from "../shared/button";
import { ImproveSection } from "./improve";
import { RankingSection } from "./ranking";
import { ScenariosSection } from "./scenarios";
import doctor from "../shared/assets/doctor.png";
import { StatisticsSection } from "./statistics";
import { PerformanceSection } from "./performance";
import { OnlineUsersSection } from "./online-users";
import { useUser } from "../shared/queries/user-query";

export function Dashboard() {
  const user = useUser();
  return (
    <div className="p-5 space-y-5">
      <div className="grid xl:grid-cols-[1117fr_649fr] gap-5">
        <div className="grid gap-5 grid-rows-[auto_1fr]">
          <Suspense
            fallback={
              <div className="rounded-[20px] bg-[#D3D3D3]/30 h-48 animate-pulse" />
            }
          >
            <section className="flex gap-[10px] rounded-[20px] bg-white shadow-card py-[10px] px-5">
              <img className="w-[105px] h-[172px]" src={doctor} alt="" />

              <div className="flex-1 grid grid-cols-[1fr_auto] gap-4 px-5 py-[10px]">
                <div>
                  <h2 className="mb-1 font-alternative text-3xl font-semibold text-[#5B5B5B]">
                    Olá, Dr. {user.name}!{" "}
                    <span className="truncate">Seja bem vindo!</span>
                  </h2>
                  {user.last_sign_in_at && (
                    <p className="mb-3 text-sm font-alternative text-[#5B5B5B]">
                      Seu último acesso foi em{" "}
                      {new Date(user.last_sign_in_at).toLocaleDateString()}
                    </p>
                  )}

                  <div className="h-20">
                    <Score />
                  </div>
                </div>
                <div className="space-y-2 ml-auto">
                  <Button asChild variant="primary-1" className="h-10 w-60">
                    <Link to="/cenarios">Começar nova prática</Link>
                  </Button>
                  <Button asChild variant="secondary-2" className="h-10 w-60">
                    <Link to="/historico">Histórico de Práticas</Link>
                  </Button>
                </div>
              </div>
            </section>
          </Suspense>
          <Suspense
            fallback={
              <div className="rounded-[20px] bg-[#D3D3D3]/30 min-h-80 h-full w-full animate-pulse" />
            }
          >
            <ImproveSection />
          </Suspense>
        </div>

        <div className="space-y-5">
          <Suspense
            fallback={
              <div className="rounded-[20px] bg-[#D3D3D3]/30 h-[236px] w-full animate-pulse" />
            }
          >
            <OnlineUsersSection />
          </Suspense>
          <Suspense
            fallback={
              <div className="rounded-[20px] bg-[#D3D3D3]/30 h-80 w-full animate-pulse" />
            }
          >
            <RankingSection />
          </Suspense>
        </div>
      </div>

      <Suspense
        fallback={
          <div className="rounded-[20px] bg-[#D3D3D3]/30 h-72 w-full animate-pulse" />
        }
      >
        <ScenariosSection />
      </Suspense>

      <div className="flex flex-wrap gap-5">
        <Suspense
          fallback={
            <div className="flex-1 rounded-[20px] bg-[#D3D3D3]/30 h-96 w-full animate-pulse" />
          }
        >
          <StatisticsSection />
        </Suspense>
        <Suspense
          fallback={
            <div className="flex-1 rounded-[20px] bg-[#D3D3D3]/30 h-96 w-full animate-pulse" />
          }
        >
          <PerformanceSection />
        </Suspense>
      </div>
    </div>
  );
}
